export default '___';

//# sourceMappingURL=groupSeparator.js.map